export default "__VITE_ASSET__ZLF4R9l9__"